import { render, staticRenderFns } from "./BasicInfoHome.vue?vue&type=template&id=1b00cebf&scoped=true&"
import script from "./BasicInfoHome.vue?vue&type=script&lang=js&"
export * from "./BasicInfoHome.vue?vue&type=script&lang=js&"
import style0 from "./BasicInfoHome.vue?vue&type=style&index=0&id=1b00cebf&scoped=true&lang=css&"
import style1 from "./BasicInfoHome.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b00cebf",
  null
  
)

export default component.exports